let xhr = require('client/xhr');
let notification = require('client/notification');
let delegate = require('client/delegate');
let FormPayment = require('payments/common/client').FormPayment;

const config = require('config');

const t = require('engine/i18n/t');

const LANG = require('config').lang;

t.i18n.add('ebook', require('../locales/' + LANG + '.yml'));

class OrderForm {

  constructor(options) {
    this.elem = options.elem;

    this.product = 'ebook';

    this.elem.addEventListener('submit', (e) => this.onSubmit(e));

    this.delegate('[data-order-payment-change]', 'click', function(e) {
      e.preventDefault();
      this.elem.querySelector('[data-order-form-step-payment]').style.display = 'block';
      this.elem.querySelector('[data-order-form-step-confirm]').style.display = 'none';
      this.elem.querySelector('[data-order-form-step-receipt]').style.display = 'none';
    });

    this.delegate('.new-complex-form__extract .extract__item', 'click', function(e) {
      e.delegateTarget.querySelector('[type="radio"]').checked = true;
    });

    this.elem.addEventListener('change', e => this.onChange(e));

    this.formPayment = new FormPayment(this, this.elem);

    this.showHidePaypalButtons();
  }


  onSubmit(event) {
    event.preventDefault();
    this.formPayment.submit();
  }

  onChange(event) {
    this.showHidePaypalButtons();
  }

  showHidePaypalButtons() {
    if (!document.querySelector('#input-paypal')) return;
    
    if (document.querySelector('#input-paypal').checked) {
      document.querySelector('[data-pay-paypal-buttons]').style.display = 'block';
      document.querySelector('[data-pay-regular-buttons]').style.display = 'none';
    } else {
      document.querySelector('[data-pay-paypal-buttons]').style.display = 'none';
      document.querySelector('[data-pay-regular-buttons]').style.display = 'block';
    }
  }

  // return orderData or nothing if validation failed
  getOrderData() {
    let orderData = {    };

    if (window.order) {
      orderData.orderNumber = window.order.number;
      orderData.amount = window.order.amount;
      orderData.title = window.order.title;
      orderData.email = window.order.email;
    } else {
      let chooser = this.elem.querySelector('input[name="orderTemplate"]:checked');
      orderData.orderTemplate = chooser.value;
      orderData.amount = chooser.dataset.price;
      orderData.title = chooser.dataset.title;
    }

    if (this.elem.elements.email) {
      if (!this.elem.elements.email.value) {
        new notification.Error(t('ebook.client.enter_email'));
        this.elem.elements.email.scrollIntoView();
        setTimeout(function() {
          window.scrollBy(0, -200);
        }, 0);
        this.elem.elements.email.focus();
        return;
      } else {
        orderData.email = this.elem.elements.email.value;
      }
    }

    if (!orderData.email) {
      orderData.email = window.currentUser.email;
    }

    return orderData;
  }



}


delegate.delegateMixin(OrderForm.prototype);

module.exports = OrderForm;
